import { createFaqSlice, faqInitialState } from '@sv-support-sdk/store';

const faq = createFaqSlice({
  name: 'faq',
  initialState: { ...faqInitialState },
  reducers: {},
});

export const faqActions = faq.actions;

export default faq.reducer;
